import Application from '@/store/Models/Application'
export default {

    // From MyLeads
    getApplications(agent_code, filters, options) {
        Application.commit((state) => {
            state.loading = true
        })
        var params = {
            ...options,
            ...filters
        }
        this.cancelQRequest("getApplicationsQ");
        return this.getRequest('/api/private/applications/' + agent_code, params, "getApplicationsQ").then(function(json) {
            if (typeof json.meta == 'undefined') {
                return json;
            }
            Application.commit((state) => {
                state.loading = false
                state.total = json.meta.total
                if (json.meta.filters) {
                    state.availableFilters = json.meta.filters
                }
            })
            return json;
        })
    },
    getSubmittedApplications(agent_code, filters, options) {
        Application.commit((state) => {
            state.loading = true
        })
        const params = {
            ...options,
            ...filters
        }
        this.cancelQRequest("getSubmittedApplications");
        return this.getRequest('/api/private/new_business/application_audit/' + agent_code, params, "getSubmittedApplications")
			.then((json) => {
				if (typeof json.meta === 'undefined') {
					Application.commit((state) => {
						state.loading = false
						state.total = json.data.length
					})
					return json;
				}

				Application.commit((state) => {
					state.loading = false
					state.total = json.meta.total
					if (json.filters) {
						state.availableFilters = json.filters
					}
				})
				return json;
			})
    },

    updatePolicyOutreachDisposition(id, disposition) {
        return this.putRequest(
            `/api/private/new_business/application_audit/${id}/outreach_disposition`,
            { PolicyOutreachDisposition: disposition }
        )
    },

	async getApplicationPdf (link) {
        if (!link) {
            return Promise.resolve({
				error: true,
				msg: 'Link is not defined',
			})
        }

        const token = await this.config()
		
        // const link = `/api/private/new_business/application_submission/${id}/view_application_pdf/${timestamp}/${hash}`
        return fetch(link, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        .then((response) => {
			if (!response.ok) {
				throw new Error(response.statusText)
			}
			const reader = response.body.getReader()
			return new ReadableStream({
				start (controller) {
					function pump () {
						return reader.read().then(({ done, value }) => {
							if (done) {
								controller.close()
								return
							}
							controller.enqueue(value)
							return pump()
						})
					}
					return pump()
				},
			})
		})
		.then((stream) => new Response(stream))
		.then((response) => response.blob())
		.then((blob) => URL.createObjectURL(blob))
		.then((url) => url)
		.catch((err) => ({ error: true, msg: err.message }))
	},
}
